import React from "react";
import { T } from "../../hooks/useTranslate";
import { Button } from "@mui/material";

interface LanguageModalButtonsProps {
  handleModalCancel: () => void;
}

const LanguageModalButtons: React.FC<LanguageModalButtonsProps> = ({ handleModalCancel }) => {
  return (
    <>
      <Button
        id="cancel-button"
        data-test-id="language-selection-cancel-button"
        aria-label="cancel filter"
        sx={{
          backgroundColor: "transparent",
          paddingLeft: "12px",
          paddingRight: "12px",
        }}
        onClick={handleModalCancel}
      >
        <T>cancel</T>
      </Button>
      <Button
        type="submit"
        id="apply-filter-button"
        data-test-id="language-selection-apply-button"
        aria-label="apply filter"
        sx={{
          color: "#FFFFFF",
          backgroundColor: "#009ECF",
          borderRadius: "4px",
          paddingLeft: "12px",
          paddingRight: "12px",
          "&:hover": {
            backgroundColor: "rgba(0, 158, 198, 0.48)",
          },
        }}
      >
        <T isTitleCase={true}>apply</T>
      </Button>
    </>
  );
};

export { LanguageModalButtons }; 